import React from 'react';
import './SiteLoading.css';

/**
 * Main website loading component - golden theme (Super Wear)
 * @param {string} title - Main loading title (e.g. "Loading Products")
 * @param {string} subtitle - Optional subtitle (e.g. "Fetching your items...")
 * @param {string} icon - Optional emoji or icon for context (e.g. "🛍️", "📦")
 * @param {string} variant - "full" (full page) or "inline" (compact for sections)
 */
const SiteLoading = ({ title = 'Loading...', subtitle, icon, variant = 'full' }) => {
  const isFull = variant === 'full';

  return (
    <div className={`site-loading ${isFull ? 'site-loading-full' : 'site-loading-inline'}`}>
      <div className="site-loading-content">
        <div className="site-loading-spinner">
          <div className="site-spinner-ring"></div>
          <div className="site-spinner-ring"></div>
          <div className="site-spinner-ring"></div>
        </div>
        {icon && <div className="site-loading-icon" aria-hidden="true">{icon}</div>}
        <h2 className="site-loading-title">{title}</h2>
        {subtitle && <p className="site-loading-subtitle">{subtitle}</p>}
        <div className="site-loading-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      {isFull && (
        <div className="site-loading-particles">
          <div className="site-particle"></div>
          <div className="site-particle"></div>
          <div className="site-particle"></div>
          <div className="site-particle"></div>
          <div className="site-particle"></div>
        </div>
      )}
    </div>
  );
};

export default SiteLoading;
